module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"h1":"Вход и регистрация","h2":"Введите номер телефона, для получения кода безопасности"}}')
  delete Component.options._Ctor
}
